module.exports = __webpack_public_path__ + "img/how_to_play@2x.ce8be721.jpg";